import lottie from 'lottie-web';
import { loadFonts } from '@loaders/FontLoader';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LoadScene' });
  }

  async preload() {
    this.load.json('loading-anim', 'assets/loadAnims/cuemath_loading.json');
    await loadFonts();
  }

  create() {
    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    this.assetsLoad();
    this.load.start();

    this.load.on(
      'progress',
      () => {
        this.loadingAnim.anim.playSegments([0, 25], true);
      },
      this,
    );

    this.load.on(
      'complete',
      () => {
        this.loadingAnim.anim.loop = false;
        this.loadingAnim.anim.playSegments([26, 41], true);
        this.loadingAnim.anim.addEventListener('complete', () => {
          this.scene.start('StartScene');
        });
      },
      this,
    );
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;
    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  assetsLoad() {
    this.load.audio('yayaudio', 'assets/Audio/Yay.wav');
    this.load.audio('bgaudio', 'assets/Audio/BG Music.mp3');
    this.load.audio('heliaudio', 'assets/Audio/Helicopter.wav');
    this.load.audio('hintaudio', 'assets/Audio/Hint Alert.mp3');
    this.load.audio('incorrectdropaudio', 'assets/Audio/wrongdrop.mp3');
    this.load.audio('wrongdivideaudio', 'assets/Audio/Incorrect_Line Division.mp3');
    this.load.audio('correctdropaudio', 'assets/Audio/Success_Drop.mp3');
    this.load.audio('correctdivideaudio', 'assets/Audio/Success_Line Division.mp3');

    for (let i = 1; i <= 10; i++) {
      this.load.audio('qa' + i, 'assets/Audio/qa' + i + 'n.mp3');
    }
    for (let i = 1; i <= 6; i++) {
      this.load.audio('ta' + i, 'assets/Audio/ta' + i + '.mp3');
    }

    this.load.image('playButton', 'assets/StartScreenAssets/Button CTA.png');
    this.load.image('startSceneBG', 'assets/StartScreenAssets/Start Screen_New.png');
    this.load.image('gameName', 'assets/StartScreenAssets/gamename.png');
    this.load.image('helicopterStatic', 'assets/StartScreenAssets/Helicopter.png');
    this.load.atlas(
      'heliAnim',
      'assets/StartScreenAssets/heliAnim.png',
      'assets/StartScreenAssets/heliAnim.json',
    );
    this.load.image('playHover', 'assets/StartScreenAssets/playHover.png');

    this.load.atlas(
      'leftButton',
      'assets/TutorialScreenAssets/arrowButtons/leftButtonAnim.png',
      'assets/TutorialScreenAssets/arrowButtons/leftButtonAnim.json',
    );
    this.load.atlas(
      'rightButton',
      'assets/TutorialScreenAssets/arrowButtons/rightButtonAnim.png',
      'assets/TutorialScreenAssets/arrowButtons/rightButtonAnim.json',
    );

    this.load.image('tutorialSceneBG', 'assets/TutorialScreenAssets/tutorialSceneBG.png');
    this.load.image('checkButton', 'assets/TutorialScreenAssets/checkButton.png');
    this.load.image('overlay', 'assets/TutorialScreenAssets/Overlay.png');
    this.load.image('speechBubble', 'assets/TutorialScreenAssets/Speech Bubble.png');
    this.load.spritesheet('numberLine', 'assets/TutorialScreenAssets/numberLine.png', {
      frameWidth: 1391,
      frameHeight: 70,
    });
    this.load.multiatlas(
      'heliHoverAnim',
      'assets/TutorialScreenAssets/heliHover/heliHoverAnim.json',
      'assets/TutorialScreenAssets/heliHover',
    );
    this.load.image('qBoard', 'assets/TutorialScreenAssets/Q Board.png');
    this.load.image('tutSceneText1', 'assets/TutorialScreenAssets/tutSceneText1.png');
    this.load.image(
      'tutSceneText2',
      'assets/TutorialScreenAssets/Start with dividing the number line into equal number of parts..png',
    );
    this.load.image(
      'tutSceneText3',
      'assets/TutorialScreenAssets/Click Check once done..png',
    );

    this.load.plugin('rexsliderplugin', 'assets/rexsliderplugin.min.js');
    this.load.plugin('rexdragplugin', 'assets/rexdragplugin.min.js');

    this.load.image('sliderButton', 'assets/TutorialScreenAssets/SliderButton.png');
    this.load.image('sliderBar', 'assets/TutorialScreenAssets/sliderbar.png');
    this.load.image('handIcon', 'assets/TutorialScreenAssets/handIcon.png');
    this.load.image('arrows', 'assets/TutorialScreenAssets/arrows.png');
    this.load.spritesheet('linePoint', 'assets/TutorialScreenAssets/numLinePoints.png', {
      frameWidth: 18,
      frameHeight: 15,
    });
    this.load.atlas(
      'checkButtonAnim',
      'assets/TutorialScreenAssets/checkButtonAnim.png',
      'assets/TutorialScreenAssets/checkButtonAnim.json',
    );
    this.load.atlas(
      'checkRightAnim',
      'assets/TutorialScreenAssets/checkRightAnim.png',
      'assets/TutorialScreenAssets/checkRightAnim.json',
    );
    this.load.atlas(
      'checkConfettiAnim',
      'assets/TutorialScreenAssets/checkConfettiAnim.png',
      'assets/TutorialScreenAssets/checkConfettiAnim.json',
    );
    this.load.image('redPoint', 'assets/TutorialScreenAssets/red point.png');
    this.load.image('greenPoint', 'assets/TutorialScreenAssets/point_3.png');
    this.load.atlas(
      'dropButtonAnim',
      'assets/TutorialScreenAssets/dropButtonAnim.png',
      'assets/TutorialScreenAssets/dropButtonAnim.json',
    );
    this.load.multiatlas(
      'heliDropAnim',
      'assets/TutorialScreenAssets/heliDrop/heliDropAnim.json',
      'assets/TutorialScreenAssets/heliDrop',
    );
    this.load.image(
      'tutSceneText4',
      'assets/TutorialScreenAssets/Move the helicopter by clicking on the Right Arrow button..png',
    );
    this.load.image('tutSceneText5', 'assets/TutorialScreenAssets/droppandatext.png');
    this.load.image('correctCounter', 'assets/TutorialScreenAssets/Correct counter.png');
    this.load.image('yellowPoint', 'assets/TutorialScreenAssets/point_2.png');

    this.load.atlas(
      'buttonWrongAnim',
      'assets/GameScreenAssets/buttonWrongAnim.png',
      'assets/GameScreenAssets/buttonWrongAnim.json',
    );
    this.load.image('rightJoystick', 'assets/GameScreenAssets/rightJoystick.png');

    this.load.multiatlas(
      'spotlight',
      'assets/EndScreenAssets/spotlight/spotlightAnimNew.json',
      'assets/EndScreenAssets/spotlight',
    );
  }

  update() {}
}
